var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactivePower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#61B785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.375 10H11.625C10.7275 10 10 10.7275 10 11.625V22.125C10 23.0225 10.7275 23.75 11.625 23.75H24.375C25.2725 23.75 26 23.0225 26 22.125V11.625C26 10.7275 25.2725 10 24.375 10ZM11.625 9C10.1753 9 9 10.1753 9 11.625V22.125C9 23.5747 10.1753 24.75 11.625 24.75H24.375C25.8247 24.75 27 23.5747 27 22.125V11.625C27 10.1753 25.8247 9 24.375 9H11.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24.875H13V26.5C13 26.9142 13.3358 27.25 13.75 27.25H22.25C22.6642 27.25 23 26.9142 23 26.5V24.875ZM12 23.875V26.5C12 27.4665 12.7835 28.25 13.75 28.25H22.25C23.2165 28.25 24 27.4665 24 26.5V23.875H12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12.5H13L13 14.875H23V12.5ZM13 11.5C12.4477 11.5 12 11.9477 12 12.5V14.875C12 15.4273 12.4477 15.875 13 15.875H23C23.5523 15.875 24 15.4273 24 14.875V12.5C24 11.9477 23.5523 11.5 23 11.5H13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 19.1C13.8314 19.1 14.1 18.8314 14.1 18.5C14.1 18.1686 13.8314 17.9 13.5 17.9C13.1686 17.9 12.9 18.1686 12.9 18.5C12.9 18.8314 13.1686 19.1 13.5 19.1ZM13.5 20C14.3284 20 15 19.3284 15 18.5C15 17.6716 14.3284 17 13.5 17C12.6716 17 12 17.6716 12 18.5C12 19.3284 12.6716 20 13.5 20Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.1C18.3314 19.1 18.6 18.8314 18.6 18.5C18.6 18.1686 18.3314 17.9 18 17.9C17.6686 17.9 17.4 18.1686 17.4 18.5C17.4 18.8314 17.6686 19.1 18 19.1ZM18 20C18.8284 20 19.5 19.3284 19.5 18.5C19.5 17.6716 18.8284 17 18 17C17.1716 17 16.5 17.6716 16.5 18.5C16.5 19.3284 17.1716 20 18 20Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 19.1C22.8314 19.1 23.1 18.8314 23.1 18.5C23.1 18.1686 22.8314 17.9 22.5 17.9C22.1686 17.9 21.9 18.1686 21.9 18.5C21.9 18.8314 22.1686 19.1 22.5 19.1ZM22.5 20C23.3284 20 24 19.3284 24 18.5C24 17.6716 23.3284 17 22.5 17C21.6716 17 21 17.6716 21 18.5C21 19.3284 21.6716 20 22.5 20Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28C28.3137 28 31 25.3137 31 22C31 18.6863 28.3137 16 25 16C21.6863 16 19 18.6863 19 22C19 25.3137 21.6863 28 25 28Z",
    fill: "#61B785"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9315 18.6652C25.0128 18.5026 25.179 18.3999 25.3608 18.3999H26.8925C27.2493 18.3999 27.4814 18.7754 27.3218 19.0946L26.4691 20.7999H26.8467C27.2422 20.7999 27.468 21.2515 27.2307 21.5679L24.2183 25.5843C23.8916 26.0199 23.2068 25.6611 23.379 25.1445L24.1872 22.7199H23.6808C23.324 22.7199 23.0919 22.3444 23.2515 22.0252L24.9315 18.6652ZM25.5091 19.1199L24.0691 21.9999H24.5202C24.8478 21.9999 25.0791 22.3209 24.9755 22.6317L24.5297 23.9692L26.3667 21.5199H26.0808C25.724 21.5199 25.4919 21.1444 25.6515 20.8252L26.5042 19.1199H25.5091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivePower);
export default __webpack_public_path__ + "static/media/reactive-power.3c18149e.svg";
export { ForwardRef as ReactComponent };